import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import { routes } from './routes';
import * as VueGoogleMaps from "vue2-google-maps";
import VueAnalytics from 'vue-analytics'


Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBfCFCw_qofJT1GE6lHlYusxFFLxVN5XdU",
    libraries: "places,drawing",
    region: 'AZ',
    language: 'az'
  }
});


Vue.use(VueRouter);


const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});


Vue.use(VueAnalytics, {
  id: 'UA-134617214-1',
  router
})


new Vue({
  el: '#app',
  router,
  render: h => h(App)
})


// Change Page Title
router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next()
})





// WEBPACK FOOTER //
// ./src/main.js